import React from 'react';

const NavigationMenuNavTitle = ({ children, mouseOver, mouseLeave }) => (
  <div onFocus={() => {}} style={{ position: 'relative' }} onMouseOver={mouseOver} onMouseLeave={mouseLeave}>
    {children}
  </div>
);

export default NavigationMenuNavTitle;
